module.exports = __webpack_public_path__ + "img/contenedor12.98410aa1.png";